/* =========================================================================
   COISA ESPERTA — página de produto (carrega no main-product, defer)
   <tw-kit>        seletor de oferta (1 unidade / Leve 2 / Leve 3): quantidade do formulário, texto do botão
                   ("Quero os 2"), resumo do kit embaixo do botão, barra fixa e botão final da PV
   Troca de variante  o assets/product-info.js troca preço e liga/desliga o botão (com o texto dos locales);
                   aqui o seletor e a barra são redesenhados pelo HTML novo e o botão volta ao texto da casa
   Barra fixa      aparece sempre que o botão de compra não está inteiro na tela; some com ele à vista ou esgotado;
                   o toque aciona o botão real (leva a oferta marcada)
   Galeria         pontinhos do celular acompanham a foto da vez
   PV              botões [data-ce-buy] compram a oferta marcada; vídeo da descrição só toca quando aparece;
                   "R$ 179,90" nunca quebra entre o R$ e o número
   Sem dependências. Os valores em R$ chegam prontos do Liquid (data-*).
   ========================================================================= */
(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const mainButton = (id) => document.getElementById('ProductSubmitButton-' + id);
  // Id da seção do main-product, pelo botão da casa (existe com ou sem seletor de oferta)
  const mainId = () => {
    const b = $('.ce-buy__btn');
    return b ? b.id.replace('ProductSubmitButton-', '') : null;
  };

  /* Espelha o botão principal (texto e travado) nos botões [data-ce-buy-label]: barra fixa e fechamento da PV */
  function syncBuy(id) {
    const btn = mainButton(id);
    if (!btn) return;
    const text = (btn.querySelector('span') || btn).textContent.trim();
    $$('[data-ce-buy-label]').forEach((el) => {
      el.textContent = text;
      if ('disabled' in el) el.disabled = btn.disabled;
    });
    const bar = document.getElementById('StickyAtc-' + id);
    if (bar && bar.ceUpdate) bar.ceUpdate();
  }

  /* ---------- Seletor de oferta ---------- */
  if (!customElements.get('tw-kit')) {
    customElements.define(
      'tw-kit',
      class TwKit extends HTMLElement {
        connectedCallback() {
          if (this.ceReady) return;
          this.ceReady = true;
          this.addEventListener('change', (e) => {
            if (e.target.classList && e.target.classList.contains('ce-kit__radio')) this.apply(e.target);
          });
          this.refresh();
        }

        refresh() {
          const checked = $('.ce-kit__radio:checked', this);
          if (checked && !this.hidden) this.apply(checked);
        }

        apply(input) {
          const d = input.dataset;
          const id = this.dataset.section;
          const qty = document.getElementById(this.dataset.qtyInput);
          if (qty) qty.value = d.qty;

          const btn = mainButton(id);
          const label = btn && btn.querySelector('span');
          if (label && !btn.disabled) label.textContent = d.label;

          // Resumo embaixo do botão: só nos kits (no 1 unidade o Pix já está no preço lá em cima)
          const root = document.getElementById('MainProduct-' + id) || document;
          $$('[data-ce-kit-sum]', root).forEach((el) => {
            el.hidden = d.qty === '1';
            el.textContent = d.sum;
          });
          // Fechamento da PV: sempre mostra a oferta marcada
          $$('[data-ce-pv-sum]').forEach((el) => (el.textContent = d.sum));

          const bar = document.getElementById('StickyAtc-' + id);
          if (bar) {
            const set = (sel, text) => {
              const el = $(sel, bar);
              if (el && text) el.textContent = text;
            };
            set('[data-ce-kit-name]', d.name);
            set('[data-ce-kit-total]', d.total);
            set('[data-ce-kit-pix]', d.pix);
          }
          syncBuy(id);
        }
      }
    );
  }

  /* ---------- Troca de variante ---------- */
  function onVariantChange({ data }) {
    const id = data && data.sectionId;
    const html = data && data.html;
    if (!id || !html) return;

    // Botão: o product-info.js pôs o texto dos locales ("Adicionar ao carrinho"/"Esgotado"); volta o da casa
    const btn = mainButton(id);
    const fresh = html.getElementById('ProductSubmitButton-' + id);
    const label = btn && btn.querySelector('span');
    const freshLabel = fresh && fresh.querySelector('span');
    if (label && freshLabel) label.textContent = freshLabel.textContent.trim();

    // Barra fixa: preços da variante nova
    const bar = document.getElementById('StickyAtc-' + id);
    const freshBar = html.getElementById('StickyAtc-' + id);
    const barInner = bar && $('.ce-sticky__inner', bar);
    const freshInner = freshBar && $('.ce-sticky__inner', freshBar);
    if (barInner && freshInner) barInner.innerHTML = freshInner.innerHTML;

    // Seletor: contas da variante nova, mantendo a oferta escolhida se ela ainda existir
    const kit = document.getElementById('TwKit-' + id);
    const freshKit = html.getElementById('TwKit-' + id);
    if (kit && freshKit) {
      const picked = $('.ce-kit__radio:checked', kit);
      kit.innerHTML = freshKit.innerHTML;
      kit.hidden = freshKit.hasAttribute('hidden');
      const again = picked && $('.ce-kit__radio[value="' + picked.value + '"]', kit);
      if (again) again.checked = true;
      if (kit.hidden) {
        $$('[data-ce-kit-sum]').forEach((el) => (el.hidden = true));
      } else {
        kit.refresh();
      }
    }
    syncBuy(id);
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  /* ---------- Barra fixa de compra ---------- */
  function initSticky(bar) {
    if (bar.ceUpdate) return;
    const target = document.getElementById(bar.dataset.target);
    if (!target) return;
    /* Pela posição a cada rolagem (1 leitura por quadro), não por IntersectionObserver: num salto de rolagem
       (voltar ao topo, âncora) o botão não chega a cruzar a tela e o observer não dispara.
       Some só com o botão INTEIRO à vista (meio botão na borda não conta) ou com o produto esgotado. */
    const update = () => {
      const r = target.getBoundingClientRect();
      const inView = r.top >= 0 && r.bottom <= window.innerHeight;
      const show = !target.disabled && !inView && r.height > 0;
      if (bar.hidden !== show) return;
      bar.hidden = !show;
      document.body.classList.toggle('ce-sticky-on', show);
    };
    bar.ceUpdate = update;
    let queued = false;
    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        update();
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    bar.addEventListener('click', (e) => {
      if (e.target.closest('.ce-sticky__btn') && !target.disabled) target.click();
    });
    update();
  }

  /* ---------- Pontinhos da galeria (celular) ---------- */
  function initDots(dots) {
    if (dots.ceReady) return;
    dots.ceReady = true;
    const slider = dots.closest('slider-component');
    if (!slider) return;
    slider.addEventListener('slideChanged', (e) => {
      const i = ((e.detail && e.detail.currentPage) || 1) - 1;
      $$('.ce-dots__dot', dots).forEach((dot, n) => dot.classList.toggle('is-on', n === i));
    });
  }

  /* ---------- PV (descrição longa) ---------- */
  document.addEventListener('click', (e) => {
    const cta = e.target.closest && e.target.closest('[data-ce-buy]');
    if (!cta) return;
    e.preventDefault();
    const id = mainId();
    const btn = id && mainButton(id);
    if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') {
      btn.click();
    } else {
      const box = document.getElementById('comprar');
      if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  function initPv(pv) {
    if (pv.ceReady) return;
    pv.ceReady = true;

    const walker = document.createTreeWalker(pv, NodeFilter.SHOW_TEXT);
    let t;
    while ((t = walker.nextNode())) {
      if (/R\$ \d/.test(t.nodeValue)) t.nodeValue = t.nodeValue.replace(/R\$ (?=\d)/g, 'R$ ');
    }

    // <video preload="none" poster="…" muted loop playsinline>: nada baixa até aparecer na tela
    const videos = $$('video', pv);
    if (!videos.length || !('IntersectionObserver' in window)) return;
    const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          const v = en.target;
          if (en.isIntersecting && !calm) {
            v.muted = true;
            v.playsInline = true;
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          } else if (!en.isIntersecting) {
            v.pause();
          }
        });
      },
      { threshold: 0.35 }
    );
    videos.forEach((v) => {
      v.setAttribute('playsinline', '');
      if (calm) v.setAttribute('controls', '');
      io.observe(v);
    });
  }

  function initAll() {
    $$('.ce-sticky[data-target]').forEach(initSticky);
    $$('[data-ce-dots]').forEach(initDots);
    $$('.ce-pv').forEach(initPv);
    const id = mainId();
    if (id) syncBuy(id);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
